import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import { MemberSearchResponseData } from '../interfaces/member-search';
import { PincodeInterface } from '../interfaces/pincode.interface';

@Injectable({
  providedIn: 'root',
})
export class UpdateMemberService extends ApiService {
  public fetchMemberDetails(
    updateObj: any
  ): Observable<MemberSearchResponseData> {
    return this.post<MemberSearchResponseData>(ROUTES.MEMBER_SEARCH, {
      body: updateObj,
    });
  }
}

@Injectable({
  providedIn: 'root',
})
export class PincodeTransmissionService extends ApiService {
  public getStateDistrict(pincode: any): Observable<PincodeInterface> {
    return this.get<PincodeInterface>(
      this.replacePathInfo(ROUTES.PINCODE, {
        pincode: pincode,
      })
    );
  }

  public getStateDistrictV2(pincode: any): Observable<PincodeInterface> {
    return this.get<PincodeInterface>(
      this.replacePathInfo(ROUTES.PINCODE_V2, {
        pincode: pincode,
      })
    );
  }

  public getForeignPinCodeDetails(country: string, postCode: string): Observable<any> {
    const params = { country, postCode }
    return this.get<any>(ROUTES.PINCODE_FOREIGN, { params });
  }
}
